// removed by extract-text-webpack-plugin
module.exports = {"component":"wzImDhnMCw3m6NNvWtZD8","remove":"_1jPueGRpHdSubXTZsZqq0a","img":"_3zhuV04lgrFRcpk8EDutsg","big":"_2TFEVdOzZTADCf2Lj6FHBi","txt":"_1WpPcjxAbjywP_qcqapiGd","span":"_3Y1syNAxLt4QAQvZULxW_","mr0":"_2_OAqNElWsgLv57rTKYTVT"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AttentionShopComponent/AttentionShopComponent.scss
 ** module id = 951
 ** module chunks = 0
 **/